import { SpinnerStyles as styles } from "../css/styles"

export const LoadingSpinner: React.FC = () => {
    return (
        <div className={styles.loadingWrapper}>
            <div className={styles.spinner}></div>
        </div>
    );
};